import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import FeatureName from "../../visComponents/featureName";
import {getPriceWithCurrency} from "../../../misc/helpers";
import {cartItemInterface} from "../cartItemInterface";
import {getSimilarItemInfoObject} from "./similarProductsFunctions";
import {featureCollectionInterface} from "../../../interfaces/featureInterface";

const SimilarProductsListItem = (props) => {

  const {cartItem, addedCountertops, featureCollection, fabricatorData, filterGroups, quoteIndex, totalCountertopsQuantity} = props;
  const fabricatorSettings = fabricatorData.settings;

  const {filterValueName, feature, subTotalPrice} = getSimilarItemInfoObject(
    cartItem,
    addedCountertops,
    featureCollection,
    totalCountertopsQuantity,
    quoteIndex,
    filterGroups
  );

  return (
    <li className="similar-item">
      <div className="similar-block">
        {filterValueName}
        <div className="similar-item__example">
          <FormattedMessage id="similar.product.example"/> <FeatureName feature={feature}/>
        </div>
      </div>
      <div className="similar-block text-right">
        <div className="similar-block__value">{getPriceWithCurrency(fabricatorSettings, subTotalPrice, feature)}</div>
      </div>
    </li>
  )
};

SimilarProductsListItem.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
  addedCountertops: PropTypes.arrayOf(PropTypes.shape(cartItemInterface)),
  featureCollection: PropTypes.shape(featureCollectionInterface),
  quoteIndex: PropTypes.number.isRequired,
  totalCountertopsQuantity: PropTypes.number.isRequired,
};

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    filterGroups: store.filterState.filterGroups,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SimilarProductsListItem)
)
